import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { ProductsService } from '../products.service';
import * as productActions from './products.actions';

@Injectable({
    providedIn: 'root'
})

export class ProductsEffects {
    constructor(
        private actions$: Actions,
        private productsService: ProductsService,
        private toastr: ToastrService,
        private miscService: MiscService
    ) {}

    fetchMerchantProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.fetchMerchantProducts),
      exhaustMap((action) =>
        this.productsService
          .getMerchantProducts()
          .pipe(
            exhaustMap((response: any) => [
                productActions.fetchMerchantProductsSuccess({ merchantProducts: response.data }),
            ]),
            catchError((error: HttpErrorResponse) => {
              if(error.status == 400){
                this.toastr.info( 'No Data');
                  return of(productActions.fetchMerchantProductsSuccess({ merchantProducts: [] }))
              }else{
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(productActions.fetchMerchantProductsFailed())
              }
            }
            )
          )
      )
    )
  );


  createProductCategory$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.createProductCategory),
    exhaustMap((action) =>
      this.productsService
        .createProductCategory(action.productCategoryDto)
        .pipe(
          exhaustMap((response: any) => [
              productActions.createProductCategorySuccess(),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(productActions.createProductCategoryFailed())
          }
          )
        )
    )
  )
);

fetchProductCatgeory$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.fetchProductCategories),
      exhaustMap((action) =>
      this.productsService
      .getProductCategory()
      .pipe(
        exhaustMap((response: any) => [
            productActions.fetchProductCategoriesSuccess({ productCategories: response.data }),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(productActions.fetchProductCategoriesFailed())
        }
        )
      )
     )
    )
  );

fetchBanks$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.fetchBanks),
      exhaustMap((action) =>
      this.miscService
      .getBanks()
      .pipe(
        exhaustMap((response: any) => [
            productActions.fetchBanksSuccess({ banks: response.data }),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured, banks could not be fetched');
            return of(productActions.fetchBanksFailed())
        }
        )
      )
     )
    )
  );


fetchWallets$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.fetchWallets),
      exhaustMap((action) =>
      this.miscService
      .getMerchantWallets()
      .pipe(
        exhaustMap((response: any) => [
            productActions.fetchWalletsSuccess({ wallets: response.data }),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured, merchant wallets could not be fetched');
            return of(productActions.fetchWalletsFailed())
        }
        )
      )
     )
    )
  );


fetchSettlementAccounts$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.fetchSettlementAccount),
      exhaustMap((action) =>
      this.miscService
      .getSettlementAccounts()
      .pipe(
        exhaustMap((response: any) => [
            productActions.fetchSettlementAccountSuccess({ settlementAccounts: response.data }),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured, settlement account could not be fetched');
            return of(productActions.fetchSettlementAccountFailed())
          }
        )
      )
     )
    )
  );

createSettlementAccounts$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.createSettlementAccount),
      exhaustMap((action) =>
      this.miscService
      .createSettlementAccount(action.settlementAccountDto)
      .pipe(
        exhaustMap((response: any) => [
            productActions.createSettlementAccountSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(productActions.createSettlementAccountFailed())
          }
        )
      )
     )
    )
  );


createMerchantWallet$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.createWallet),
      exhaustMap((action) =>
      this.miscService
      .createMerchantWallet(action.walletDto)
      .pipe(
        exhaustMap((response: any) => [
            productActions.createWalletSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(productActions.createWalletFailed())
          }
        )
      )
     )
    )
  );

createProduct$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.createProduct),
      exhaustMap((action) =>
      this.productsService
      .createProduct(action.productDto)
      .pipe(
        exhaustMap((response: any) => [
            productActions.createProductSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(productActions.createProductFailed())
          }
        )
      )
     )
    )
  );

editProduct$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.editProduct),
      exhaustMap((action) =>
      this.productsService
      .editProduct(action.productDto)
      .pipe(
        exhaustMap((response: any) => [
            productActions.editProductSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(productActions.editProductFailed())
          }
        )
      )
     )
    )
  );

  validateAccount$ = createEffect(() =>
  this.actions$.pipe(
    ofType(productActions.validateAccount),
      exhaustMap((action) =>
      this.miscService
      .validateAccount( action.bankCode, action.accountNumber, action.countryCode)
      .pipe(
        exhaustMap((response: any) => [
            productActions.validateAccountSuccess({ accountDetails: response.data }),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(productActions.validateAccountFailed())
          }
        )
      )
     )
    )
  );

}